import axios from 'axios';
import Cookies from 'js-cookie';
import { site } from '@panel/commons/helpers';

/**
 * Llama al endpoint de envío de email al generarse una compra
 * con éxito
 * @param {RequestResponseData} data
 */
export const sendPaymentNotification = async (paymentType, data) => {
  const headers = {
    'Access-Control-Allow-Origin': window.location.origin,
    'x-panel-portal': site.id,
    'X-NAVENT-APP': 'publicador',
    sessionId: Cookies.get('sessionId')
  };
  try {
    await axios.post(`${process.env.REACT_APP_API_ECOMMERCE}/ecommerce/api/v1/mail/${paymentType}`, data, { headers });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to send purchase confirmation:', err);
  }
};
